import { Container, TextField, Button, Box } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { styled } from "@mui/material/styles";
import { SkipPrevious } from "@mui/icons-material";

export const StyledContainer = styled("div")(({ theme }) => ({
  padding: "30px 40px",
  textAlign: "center",
  background: "#fff",
  maxWidth: "100%",
  margin: "0 auto",
  border: "none",
  [theme.breakpoints.down("sm")]: {
    padding: "20px",
  },
}));

export const StyledBox = styled(Box)(({ theme }) => ({
  backgroundColor: "#f9f9f9",
  minHeight: "100vh",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

export const StyledContainers = styled(Container)(({ theme }) => ({
  padding: "30px 40px",
  borderRadius: "8px",
}));

export const StyledButton = styled(Button)(({ theme }) => ({
  backgroundColor: "#06214b",
  borderRadius: "20px",
  color: "#fff",
  fontWeight: "bold",
  "&:hover": {
    backgroundColor: "#06214b",
  },
}));
export const StyledButton1 = styled(Button)(({ theme }) => ({
  backgroundColor: "#fff",
  borderRadius: "20px",
  color: "#9f9f9f",
  fontWeight: "bold",
  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",

  "&:hover": {
    backgroundColor: "#06214b",
    boxShadow: "0 8px 16px rgba(0, 0, 0, 0.2)",
  },
}));
export const StyledButton2 = styled(Button)(({ theme }) => ({
  backgroundColor: "#0866ff",
  borderRadius: "20px",
  color: "#FFF",
  fontWeight: "bold",

  "&:hover": {
    backgroundColor: "#06214b",
  },
}));
//#0866ff
export const StyledTextField = styled(TextField)(({ theme }) => ({
  "& .MuiInputBase-root": {
    backgroundColor: "#fff",
    borderRadius: "4px",
    padding: "20px 10px",
    "& input": {
      fontFamily: "Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 400,
      fontSize: "1rem",
      lineHeight: "1.4375em",
      letterSpacing: "0.00938em",
      color: "rgba(0, 0, 0, 0.87)",
      height: "10px",
      border: "none",
      outline: "none",
    },
    "& fieldset": {
      padding: 10,
      borderRadius: "10px",
      border: "2px solid #d8dee6",
    },
    "&:hover fieldset": {
      border: "2px solid #d8dee6",
    },
    "&.Mui-focused fieldset": {
      border: "2px solid #d8dee6",
    },
  },
  "& label": {
    fontSize: "13px",
    color: "#a0a0a0",
  },
  "& label.Mui-focused": {
    color: "#333",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "#ccc",
  },
  "& .MuiOutlinedInput-notchedOutline.Mui-focused": {
    borderColor: "#333",
  },
  "& .MuiOutlinedInput-notchedOutline.Mui-error": {
    borderColor: "#f44336",
  },
  "& .MuiOutlinedInput-notchedOutline.Mui-disabled": {
    borderColor: "#ccc",
  },
  "&.Mui-error": {
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#f44336",
    },
    "& label": {
      color: "#f44336",
    },
  },
  "&.Mui-disabled": {
    "& input": {
      backgroundColor: "#f5f5f5",
      color: "#a0a0a0",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#ccc",
    },
  },
}));
export const paginationStyles = {
  PreviousButton: {
    backgroundColor: "#2f4cdd",
    color: "#fff !important",
    fontWeight: "bold",
    width: { xs: "100px", sm: "130px" },
    fontSize: { xs: "9px", sm: "12px" },
    height: "40px",
    margin: "0 10px",
    "&:hover": {
      backgroundColor: "#2f4cdd",
    },
  },
  arrayButtons: {
    borderRadius: "5px",
    width: { xs: "5px", sm: "10px" },
    height: "30px",
    border: "none",
    cursor: "pointer",
    margin: { xs: "2px 2px", sm: "5px 5px" },
    minWidth: "34px",
    display: {
      xs: "none",
      sm: "none",
      md: "inline",
      lg: "inline",
      xl: "inline",
    },
  },
  nextButton: {
    backgroundColor: "#2f4cdd",
    color: "#fff !important",
    fontWeight: "bold",
    fontSize: { xs: "9px", sm: "12px" },
    width: { xs: "100px", sm: "100px" },
    height: "40px",
    margin: "0 10px",
  },
};

export const CapsuleValue = styled("div")(({ theme }) => ({
  display: "inline-block",
  fontWeight: "600",
  textAlign: "center",
  minWidth: "60px",
  marginTop: "0px",
  height: "25px",
  lineHeight: "25px",
  borderRadius: "12.5px",
  backgroundColor: "#ccc",
}));

export const ActiveValue = styled("div")(({ theme }) => ({
  display: "inline-block",
  fontWeight: "600",
  textAlign: "center",
  minWidth: "70px",
  marginTop: "0px",
  height: "25px",
  lineHeight: "25px",
  borderRadius: "12.5px",
  backgroundColor: "#d4edda",
  color: "#155724",
}));

export const InactiveValue = styled("div")(({ theme }) => ({
  display: "inline-block",
  fontWeight: "600",
  textAlign: "center",
  minWidth: "80px",
  marginTop: "0px",
  height: "25px",
  lineHeight: "25px",
  borderRadius: "12.5px",
  backgroundColor: "#f8d7da",
  color: "#721c24",
}));
